import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import TechnicalScoringRubric from './TechnicalScoringRubric';
import ArtisticScoringRubric from './ArtisticScoringRubric';
import usePageTitle from '../../shared/hooks/usePageTitle';

function RubricPage() {
  usePageTitle('OSSDF Rubric');
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ maxWidth: '1100px', margin: '0 auto', padding: '24px' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Technical Rubric" />
          <Tab label="Artistic Rubric" />
        </Tabs>
      </Box>

      {tab === 0 && <TechnicalScoringRubric />}
      {tab === 1 && <ArtisticScoringRubric />}
    </Box>
  );
}

export default RubricPage;
